import { MenuItemContext } from '@nx-icilalune/data/icilalune/types';

export function setThemeColorVars(
  colorSpace: MenuItemContext | undefined,
  element: HTMLElement
) {
  if (colorSpace) {
    const lightVarName = `--lune-color-section-${colorSpace}-light`;
    const defaultVarName = `--lune-color-section-${colorSpace}-default`;
    const darkVarName = `--lune-color-section-${colorSpace}-dark`;
    const contrastVarName = `--lune-color-section-${colorSpace}-contrast`;
    const rawVarName = `--lune-color-section-${colorSpace}-default-raw`;
    element.style.setProperty('--themeColor', `var(${defaultVarName})`);

    element.style.setProperty('--themeColor-light', `var(${lightVarName})`);

    element.style.setProperty('--themeColor-dark', `var(${darkVarName})`);

    element.style.setProperty(
      '--themeColor-contrast',
      `var(${contrastVarName})`
    );

    element.style.setProperty('--themeColor-raw', `var(${rawVarName})`);
  } else {
    element.style.setProperty('--themeColor', null);

    element.style.setProperty('--themeColor-light', null);

    element.style.setProperty('--themeColor-dark', null);
    element.style.setProperty('--themeColor-contrast', null);
    element.style.setProperty('--themeColor-raw', null);
  }
}
